class ServiceBrokerController {
    constructor(ServiceBrokerServiceApi, UtpSimServiceApi, moment, toastr) {
        this.$onInit = () => {
            this.renderStatus();
            this.testApi(true);
            this.testApiDBConnection(true);
            this.testApiAdminService(true);
        };
        this.renderStatus = () => {
            this.ServiceBrokerService.status().then((response) => {
                this.status = response.data;
                this.title = 'Status';
                let maxUtpTraceId = this.status.MaxUtpTraceId;
                let utpTracesNewMaxId = this.status.UtpTracesNew.UtpTraceId;
                this.showWarning = utpTracesNewMaxId < maxUtpTraceId;
            });
        };
        this.resetUtpTracesNew = () => {
            this.ServiceBrokerService.synchUtpTracesNewTraceId().then(() => {
                this.renderStatus();
            });
        };
        this.getFromNowString = (utcTime) => {
            let utc = this.moment.utc(utcTime);
            let local = this.moment(utc).local();
            return this.moment(local).fromNow();
        };
        this.testApi = (showToaster) => {
            this.UTPSimService.testApi().then((response) => {
                if (angular.isUndefined(response)) {
                    this.toastr.error('Problem reaching Web Api, please contact system administrator!');
                    this.testApiStatusDesc = 'API is not running';
                    return;
                }
                if (!response.data) {
                    this.toastr.warning('API Rejected Request');
                    return;
                }
                this.testApiStatus = response.data;
                if (showToaster) {
                    this.toastr.info('Web Api running');
                }
                this.testApiStatusDesc = 'Web API is running';
                return;
            });
        };
        this.testApiDBConnection = (showToaster) => {
            this.UTPSimService.testApiDBConnection().then((response) => {
                if (angular.isUndefined(response)) {
                    this.toastr.error('Problem reaching Web Api, please contact system administrator!');
                    this.testApiDbStatusDesc = 'Api Service no DB connection!';
                    return;
                }
                if (!response.data) {
                    this.toastr.warning('API Rejected Request!');
                    return;
                }
                this.testApiDbStatus = response.data;
                if (showToaster) {
                    this.toastr.info('Api Service DB OK');
                }
                this.testApiDbStatusDesc = 'Api Service DB OK';
                return;
            });
        };
        this.testApiAdminService = (showToaster) => {
            this.UTPSimService.testApiAdminService().then((response) => {
                let result = response.data;
                if (angular.isUndefined(response) || angular.isUndefined(response.data) || !result.IsApiAdminServiceRunning) {
                    for (let failedServer of result.FailedServers) {
                        this.toastr.error(`Problem reaching Admin Service at ${failedServer} , please contact system administrator!`);
                    }
                    this.testApiAdminStatusDesc = 'Admin Service NOK!';
                    return;
                }
                this.testApiAdminStatus = response.data.IsApiAdminServiceRunning;
                if (showToaster) {
                    this.toastr.info('Admin Service OK');
                }
                this.testApiAdminStatusDesc = 'Admin Service OK';
                return;
            });
        };
        this.ServiceBrokerService = ServiceBrokerServiceApi;
        this.UTPSimService = UtpSimServiceApi;
        this.moment = moment;
        this.toastr = toastr;
    }
}
angular.module('app').component('serviceBroker', {
    bindings: {},
    templateUrl: 'scripts/app/partials/SystemHealth/service-broker.tpl.html',
    controllerAs: 'vm',
    controller: ServiceBrokerController
});
